module.exports = __webpack_public_path__ + "img/Failed.c0197cba.svg";